(function(){
    'use strict';

    angular
    .module('app')
    .controller('DecimalconfigController', DecimalconfigController)
 
    DecimalconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function DecimalconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.busqueda = false;
        vm.field = "";
        vm.update = function(){
			/*var j = {
				"references":{
					"num_decimales":vm.num_decimales
				}
			};*/
            console.log("vm",vm);
            var j = JSON.parse($('#fieldconfig-value').val());
            j.references["num_decimales"] = vm.num_decimales;
            
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
                if(typeof vm.json.references.num_decimales!='undefined'){
                    vm.num_decimales = vm.json.references.num_decimales;
                }
        	}
        	vm.update();
        }
    } 

})();